var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.status)?_c('v-chip',{staticClass:"font-weight-regular ml-2",attrs:{"outlined":"","small":"","color":"secondarytext"}},[_c('v-badge',{attrs:{"dot":"","inline":"","color":_vm.statusColor}},[_vm._v(_vm._s(_vm.status))])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }